import React from 'react'

export default function Page_404() {
	return (
		<div className='justify-content-center'>
			Please log in to see this page
		</div>
	)
}
